<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="tax" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "tax-view-logs",

  components: { LogListTable },

  props: ["tax"],

  data() {
    return {};
  },
};
</script>
